import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import GrayButton from "../../../../../components/UI/buttonUI/GrayButton";
import CylinderDropdown from "../../../../../components/UI/PageInput/CylinderDropdown";
import PeriodSelector from "../PeriodSelector";
import PrimaryButton from "../../../../../components/UI/buttonUI/PrimaryButton";
import { CYLINDER_HISTORY } from "../../../../../api/allApi_List";
import { formatDateString } from "../../../../../functions/dateTime/formatDateString";
import CustomDateSelector from "../CustomDateSelector";
import { History } from "lucide-react";

const CylinderHistoryForm = ({
  setupData,
  historyLoaded,
  getHistory,
  setIsSucceed,
  isSucceed,
  setError,
  historyError,
}) => {
  const dispatch = useDispatch();
  const now = new Date();
  const fromDate = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      from: fromDate,
      to: now,
      currentSelector: "lastWeek",
    },
  });
  const { id, from, to, currentSelector } = watch();
  const onSubmit = () => {
    getHistory(
      `${CYLINDER_HISTORY}${id}/${formatDateString(from)}/${formatDateString(
        to
      )}`
    );
  };

  const handleClear = () => {
    isSucceed && setIsSucceed(false);
    historyError && dispatch(setError("false"));
    reset();
  };
  return (
    <form
      className="cy-history-form"
      onSubmit={historyLoaded ? () => {} : (e) => handleSubmit(onSubmit)(e)}
    >
      <CylinderDropdown
        label="Cylinder No.*"
        name={`id`}
        options={setupData}
        setValue={setValue}
        control={control}
        error={errors.id}
      />
      <PeriodSelector setValue={setValue} currentSelector={currentSelector} />
      {currentSelector === "custom" && (
        <CustomDateSelector
          from={from}
          to={to}
          register={register}
          setValue={setValue}
          errors={errors}
        />
      )}
      <div className="submitWrap">
        <p className="addWrap">
          <PrimaryButton
            btnText={historyLoaded ? "Loading..." : "Get History"}
            loading={historyLoaded}
            Icon={History}
            size={20}
          />
        </p>
        <p className="grayWrap">
          <GrayButton
            btnText="Cancel"
            width="w-40"
            onClick={() => handleClear()}
          />
        </p>
      </div>
    </form>
  );
};
export default CylinderHistoryForm;